<template>
  <div class="page-container">
    <div class="account-card">
      <span class="page-title">個人帳號</span>
      <div class="card-content">
        <div class="header">
          <form class="form" @submit.prevent="saveAccount">
            <div class="section-title">基本資訊</div>
            <div class="grid-container">
              <div class="form-group">
                <label for="lastName">姓氏</label>
                <input id="lastName" type="text" v-model="user.last_name"/>
              </div>
              <div class="form-group">
                <label for="firstName">名字</label>
                <input id="firstName" type="text" v-model="user.first_name"/>
              </div>
              <div class="form-group">
                <label for="role">權限</label>
                <input id="role" type="text" :value="$t(`roles.${user.role}`)" disabled/>
              </div>
              <div class="form-group">
                <label for="company">公司</label>
                <input id="company" type="text" :value="user.organization?.name || '無'" disabled/>
              </div>
              <div class="form-group">
                <label for="email">電子信箱</label>
                <input id="email" type="email" :value="user.email" disabled/>
              </div>
              <div class="form-group password-group">
                <label for="password">密碼</label>
                <div class="password-row">
                  <input id="password" type="password" :value="user.password" disabled/>
                  <button type="button" class="edit-password-btn" @click="editPassword">修改密碼</button>
                </div>
                <small>最後修改日期：{{ user.lastModified }}</small>
              </div>
            </div>
            <div class="buttons">
              <button type="button" class="btn-cancel" @click="cancelChanges">取消</button>
              <button type="submit" class="save-btn">儲存</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {message} from "ant-design-vue";

export default {
  inject: ['getUserData', 'setUserData'],
  data() {
    return {};
  },
  computed: {
    user() {
      return this.getUserData()
    }
  },
  methods: {
    saveAccount() {
      // 儲存邏輯
      console.log("儲存使用者資料:", this.user);

      const token = localStorage.getItem('token');
      this.$axios.patch('/api/users/profile', {
        first_name: this.user.first_name,
        last_name: this.user.last_name
      }, {
        headers: {
          Authorization: `Bearer ${token}`
        },
      }).then(response => {
        console.log(response);

        this.$axios.get('/api/users/profile', {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }).then(response => {
          message.success("已完成帳號編輯");
          const profile = response.data.data;
          this.setUserData(profile);
          this.$router.push('/profile');

        }).catch(error => {
          console.error(error);
        });

      }).catch(error => {
        console.error(error);
      });
    },
    cancelChanges() {

      this.$router.go(-1)
    },
    editPassword() {

    },
  },
};
</script>

<style scoped>
.card-content {
  background-color: white;
  border-radius: 8px;
  margin-top: 16px;
  max-width: 800px;
}

.header {
  align-items: center;
  padding: 28px 32px;
}

.section-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 16px;
}

.form {
  display: flex;
  flex-direction: column;
}

.grid-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px 24px;
  margin-bottom: 24px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group label {
  font-size: 14px;
  color: #555;
  margin-bottom: 8px;
}

.form-group input {
  padding: 8px 12px;
  border: 1px solid #ccc;
  border-radius: 8px;
}

.password-group .password-row {
  display: flex;
  gap: 8px;
}

.edit-password-btn {
  border: none;
  background: none;
  color: #007bff;
  font-size: 14px;
  cursor: pointer;
}

.edit-password-btn:hover {
  text-decoration: underline;
}

.buttons {
  display: flex;
  justify-content: flex-end;
  gap: 16px;
}

.buttons button {
  border: 2px solid #0000ff;
  background: none;
  color: #0000ff;
  width: 150px;
  height: 36px;
  border-radius: 12px;
  margin-left: 10px;
  cursor: pointer;
  font-size: 18px;
  font-weight: bold;
}

.save-btn {
  background-color: #0000ff !important;
  color: white !important;
}
</style>
